import React from 'react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-forest-deep px-4 py-12 sm:py-16" data-id="element-136" data-mp="5f3fysd94bms">
      <div className="mx-auto max-w-2xl text-center" data-id="element-137" data-mp="3mt8q7i3qx10i">
        <h2 className="font-display text-[26px] font-black leading-tight text-white sm:text-4xl" data-id="element-138" data-mp="3rsblwbxu5uvt">
          Every Consultation Is an Opportunity to Make a Better Decision.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-white/75 sm:text-lg" data-id="element-139" data-mp="3hufe9u43xi2g">
          The difference between guessing and acting with confidence can be as simple as having the
          right system within reach. Start following a Clinical Pathway designed to simplify obesity
          management.
        </p>

        <div className="mt-6 inline-flex flex-col items-center rounded-3xl bg-white/[0.07] px-6 py-5 ring-1 ring-white/15" data-id="element-140" data-mp="124ufx74baqzz">
          <span className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-white/60" data-id="element-141" data-mp="170jkjov6uy35">
            Immediate access for
          </span>
          <span className="mt-1 font-display text-5xl font-black leading-none text-white" data-id="element-142" data-mp="labzkhxqd7je">
            $27 <span className="align-super text-lg" data-id="element-143" data-mp="z16zh4q94eau">USD</span>
          </span>
          <span className="mt-2 text-[12px] font-semibold text-white/60" data-id="element-144" data-mp="uzbxrz4erywj">
            💱 Currency conversion applied automatically by country
          </span>
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-145" data-mp="7bvgrsmlfqkw">
          <CTAButton label="I want the Clinical Kit now" data-id="element-146" data-mp="2bg5d6lvgt5k" />
          <p className="mt-3 text-[13px] font-medium text-white/60" data-id="element-147" data-mp="2d10axc3me3y">
            Instant Download • One-Time Payment • Lifetime Access • 7-Day Guarantee
          </p>

          <div className="mt-7" data-id="element-148" data-mp="b9t6qxo6ugpc">
            <Countdown tone="dark" data-id="element-149" data-mp="bdpdjpto4afs" />
          </div>
          <div className="mt-7" data-id="element-150" data-mp="1rokxl65orfwj">
            <ScarcityBar tone="dark" data-id="element-151" data-mp="1rrpd2zolpy2i" />
          </div>
        </div>
      </div>
    </section>;
}